import { location, placeName } from './location.svelte'
import { savedFor, type SavedPlace } from './places.svelte'

/**
 * What the headers call the point on screen. A saved place is called by its
 * saved name, whether it was opened as that place or is merely within 1 km of
 * it (a tap beside Home is Home); anything else by `placeName()`.
 *
 * Its own module because `places.svelte.ts` must not import the selection:
 * `location` imports `prefs`, which loads the places.
 */

export function shownPlace(): SavedPlace | null {
  return savedFor(location.selected)
}

export function shownName(): string | null {
  return shownPlace()?.name ?? placeName()
}

/** The NWS name beside a custom one: "Home · Lawrence, KS". Null when they are the same. */
export function shownAside(): string | null {
  const saved = shownPlace()
  return saved?.label && saved.label !== saved.name ? saved.label : null
}
